import { createFileRoute, redirect } from '@tanstack/react-router'
import OAuthAdmin from '@admin/preferences/OAuthAdmin'
import { AuthZQueries } from '@admin/data/OAuth'
import { useSuspenseQuery } from '@tanstack/react-query'

export const Route = createFileRoute('/_auth/preferences/oauthAdmin')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Admin', 'READ')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([queryClient.ensureQueryData(AuthZQueries.clients())])
  },
})

function RouteComponent() {
  const { data: clients } = useSuspenseQuery(AuthZQueries.clients())
  return <OAuthAdmin clients={clients} />
}
